import React from "react";

const Header = () => {
  return (
    <header className="bg-gray-800 py-6 relative w-full">
      <h1 className="text-white	text-center text-base md:text-xl ">
        {" "}
        React Contact Book{" "}
      </h1>
    </header>
  );
};

export default Header;
